import React from "react";

const ActionModal = ({
  show,
  title = "",
  modalBody,
  confirmText = "Yes",
  cancelText = "No",
  isSubmitting = false,
  onConfirm,
  onCancel,
  size = "sm", // sm | lg | xl
}) => {
  const sizeClass = {
    sm: "",
    lg: "modal-lg",
    xl: "modal-xl",
  }[size];

  if (!show) return null;

  return (
    <div className="custom-project-modal">
      <div className="modal-backdrop fade show"></div>

      <div
        className="modal fade show"
        tabIndex="-1"
        aria-hidden="true"
        style={{ display: "block", zIndex: 1050 }}
      >
        <div className={`modal-dialog mx-auto ${sizeClass}`}style={{ marginTop: "15%" }}>
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">{title}</h5>
            </div>

            <div className="modal-body">{modalBody}</div>

            {onConfirm && onCancel && (
              <div className="d-flex justify-content-center gap-5">
                <fieldset
                  disabled={isSubmitting}
                  style={{ border: 0, padding: 0, margin: 0 }}
                >
                  <button className="btn btn-danger px-5" onClick={onConfirm}>
                    {isSubmitting ? "Processing..." : confirmText}
                  </button>
                </fieldset>

                <button className="btn btn-secondary px-5" onClick={onCancel}>
                  {cancelText}
                </button>
              </div>
            )}

            <div className="py-3" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ActionModal;
